import { Component, ViewEncapsulation } from '@angular/core';

interface ProductInfo {
  name: string; // Display name of the product
  prices?: number[]; // Price bands, from 1 to 10
  link?: string;
  isBundle?: boolean;
  isDiscount?: boolean;
  discount?: number;
  daggers?: number;
}

@Component({
  templateUrl: 'subscriptions.component.html',
  styleUrls: ['subscriptions.component.scss'],
  encapsulation: ViewEncapsulation.None, // Required so we can adjust some css properties of mat tab
})
export class SubscriptionsComponent {
  readonly bands = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  readonly productInfo: ProductInfo[] = [
    {
      name: 'Ultimate Bundle',
      prices: [16433, 15024, 12723, 11965, 9505, 9339, 5493, 4329, 4141, 4019],
      isBundle: true,
    },
    {
      name: 'Premium Bundle',
      prices: [15013, 13708, 11647, 10957, 8724, 8294, 4993, 4034, 3863, 3736],
      isBundle: true,
    },
    {
      name: 'Standard Bundle',
      prices: [11713, 10940, 9334, 9019, 7137, 6974, 3882, 3108, 3098, 3098],
      isBundle: true,
    },
    {
      name: 'OS',
      prices: [7528, 7186, 6306, 6017, 5203, 4867, 2726, 1853, 1842, 1842],
      link: '/os',
    },
    {
      name: 'Marine',
      prices: [3817, 3817, 2443, 2291, 1069, 996, 645, 578, 578, 564],
      link: '/marine',
    },
    {
      name: 'aerial-lidar-special-case',
      prices: [3318, 2788, 2322, 1952, 1593, 1329, 1115, 931, 770, 645],
    },
    {
      name: 'geology-special-case',
      prices: [1519, 1519, 902, 902, 562, 562, 297, 297, 297, 297],
      link: '/geology',
    },
    {
      name: 'Global',
      prices: [1195, 1142, 1002, 958, 828, 775, 433, 296, 296, 296],
      link: '/global',
    },
    {
      name: 'Historic',
      prices: [1299, 1299, 1205, 1205, 1053, 1053, 588, 588, 588, 588],
      link: '/historic',
      daggers: 1,
    },
    {
      name: 'Society',
      prices: [797, 762, 669, 639, 553, 516, 289, 197, 197, 197],
      link: '/society',
      daggers: 1,
    },
    {
      name: 'Environment',
      prices: [670, 584, 532, 494, 468, 404, 378, 290, 290, 290],
      link: '/environment',
    },
    {
      name: 'Verisk',
      prices: [2466, 2356, 2068, 1974, 1709, 1600, 894, 608, 608, 608],
      link: '/verisk',
    },
    {
      name: 'agCensus',
      prices: [1307, 1307, 1088, 1088, 871, 871, 653, 653, 435, 435],
      link: '/agcensus',
    },
    {
      name: 'OS National Geographic Database (NGD)',
      prices: [4460, 4261, 3740, 3573, 3091, 2895, 1617, 1099, 1099, 1099],
      link: '/whats-new#ngd',
      daggers: 1,
    },
    {
      name: 'Purchase with Ultimate bundle*',
      isDiscount: true,
      discount: 30,
      link: '/whats-new#ngd',
    },
    {
      name: 'Purchase with Premium bundle*',
      isDiscount: true,
      discount: 20,
      link: '/whats-new#ngd',
    },
    {
      name: 'Purchase with Standard bundle*',
      isDiscount: true,
      discount: 10,
      link: '/whats-new#ngd',
    },
    {
      name: 'National Tree Map',
      prices: [2753, 2569, 1844, 1514, 1193, 918, 643, 551, 504, 459],
      link: '/help/our-maps-and-data/national_tree_map/',
      daggers: 1,
    },
    {
      name: 'Purchase with Ultimate bundle*',
      isDiscount: true,
      discount: 20,
      link: '/help/our-maps-and-data/national_tree_map/',
    },
    {
      name: 'Purchase with Premium bundle*',
      isDiscount: true,
      discount: 15,
      link: '/help/our-maps-and-data/national_tree_map/',
    },
    {
      name: 'Purchase with Standard bundle*',
      isDiscount: true,
      discount: 10,
      link: '/help/our-maps-and-data/national_tree_map/',
    },
    {
      name: 'Aerial Extra bought with Aerial & Lidar',
      prices: [1245, 1046, 872, 732, 598, 498, 419, 349, 289, 242],
      link: '/help/our-maps-and-data/aerial_products/#aerial-extra',
      daggers: 2,
    },
    {
      name: 'Purchase with Ultimate bundle*',
      isDiscount: true,
      discount: 12.5,
      link: '/help/our-maps-and-data/aerial_products/#aerial-extra',
    },
    {
      name: 'Purchase with Premium bundle*',
      isDiscount: true,
      discount: 6,
      link: '/help/our-maps-and-data/aerial_products/#aerial-extra',
    },
    {
      name: 'LandClan (pending confirmation of licensing)',
      prices: [1365, 1305, 1145, 1094, 947, 886, 495, 336, 336, 336],
      link: '/whats-new#landclan',
      daggers: 1,
    },
    {
      name: 'Purchase with Ultimate* bundle',
      isDiscount: true,
      discount: 20,
      link: '/whats-new#landclan',
    },
    {
      name: 'Purchase with Premium bundle*',
      isDiscount: true,
      discount: 15,
      link: '/whats-new#landclan',
    },
    {
      name: 'Purchase with Standard bundle*',
      isDiscount: true,
      discount: 10,
      link: '/whats-new#landclan',
    },
  ];

  getBundles(): ProductInfo[] {
    return this.productInfo.filter(product => product.isBundle);
  }

  getProducts(): ProductInfo[] {
    return this.productInfo.filter(product => !product.isBundle);
  }
}
